module.exports = fox._r("flash/player.swf", __webpack_public_path__ + "_/_/_/root/flash/player.swf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/flash/player.swf
// module id = 676
// module chunks = 4